import { MessageDraftStatus } from '@graphql/generated-base';

export type DraftRowBucket = 'draft' | 'scheduled' | 'failed-scheduled' | 'other';

type ClassifiableRow = Readonly<{
  status: MessageDraftStatus;
  scheduledAt?: string | null;
}>;

type ClassifyOptions = Readonly<{
  schedulingFlagEnabled: boolean;
}>;

// Single source of truth for which messaging tab a `messageDraftsByEvent` row belongs to.
// Two rollback-sensitive rules live here:
//  - PRO-397 failed-scheduled rows (`failed && scheduledAt`) belong on the Scheduled tab so
//    admins fix them where they originally scheduled them. They must NOT also appear in Drafts.
//  - When the scheduling flag is OFF the Scheduled tab is hidden — `scheduled` and
//    `failed-scheduled` rows then fall back into Drafts so the live BE rows remain
//    visible/cancellable; otherwise admins lose the ability to manage scheduled sends
//    that were created before rollback.
export const classifyDraftRow = (row: ClassifiableRow, { schedulingFlagEnabled }: ClassifyOptions): DraftRowBucket => {
  if (row.status === MessageDraftStatus.failed && row.scheduledAt) {
    return schedulingFlagEnabled ? 'failed-scheduled' : 'draft';
  }
  if (row.status === MessageDraftStatus.scheduled) {
    return schedulingFlagEnabled ? 'scheduled' : 'draft';
  }
  if (row.status === MessageDraftStatus.draft || row.status === MessageDraftStatus.failed) {
    return 'draft';
  }
  return 'other';
};
